/* import __COLOCATED_TEMPLATE__ from './stripe-cc-modal-form.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { isStripeValidationError } from 'sh-www/services/stripe';

class StripeCreditCardModalFormComponent extends Component {
  @tracked globalError = null;
  @tracked event = null;

  get complete() {
    return Boolean(this.event?.complete);
  }

  get error() {
    return this.event?.error?.message || this.globalError;
  }

  get disabled() {
    return !this.complete || this.submitTask.isRunning;
  }

  @action
  handleChange(event) {
    this.globalError = null;
    this.event = event;
  }

  @dropTask
  *submitTask(elements) {
    const cardElement = elements.getElement('card');

    this.globalError = null;

    try {
      yield this.args.onSubmit(cardElement);
    } catch (e) {
      // we can ignore stripe validation errors because it will have already triggered a change
      // event, which we capture
      if (!isStripeValidationError(e)) {
        this.globalError =
          'There was an unknown error updating your payment information. ' +
          'Please refresh the page and try again.';
      }
    }
  }
}

export default StripeCreditCardModalFormComponent;
